import LocaleContext from "./LocaleContext";
import React, { useContext } from "react";
import allLocales from "./locale";
import cs from "classnames";
function getAllDays(date) {
    const startDate = date.startOf('month');
    const day = startDate.day();
    const daysInfo = new Array(6 * 7);
    for (let i = 0; i < day; i++) {
        daysInfo[i] = {
            date: startDate.subtract(day - i, 'day'),
            currentMonth: false
        };
    }
    for (let i = day; i < daysInfo.length; i++) {
        const calcDate = startDate.add(i - day, 'day');
        daysInfo[i] = {
            date: calcDate,
            currentMonth: calcDate.month() === date.month()
        };
    }
    return daysInfo;
}
function MonthCalendar(props) {
    const localeContext = useContext(LocaleContext);
    const { value, curMonth, dateRender, dateInnerContent, selectHandler } = props;
    const CalendarLocale = allLocales[localeContext.locale];
    const weekList = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const allDays = getAllDays(curMonth);
    function renderDays(days) {
        const rows = [];
        for (let i = 0; i < 6; i++) {
            const row = [];
            for (let j = 0; j < 7; j++) {
                const item = days[i * 7 + j];
                row[j] = React.createElement("div", { className: "calendar-month-body-cell " + (item.currentMonth ? 'calendar-month-body-cell-current' : ''), onClick: () => selectHandler === null || selectHandler === void 0 ? void 0 : selectHandler(item.date) }, dateRender ? dateRender(item.date) : (React.createElement("div", { className: "calendar-month-body-cell-date" },
                    React.createElement("div", { className: cs("calendar-month-body-cell-date-value", value.format('YYYY-MM-DD') === item.date.format('YYYY-MM-DD')
                            ? "calendar-month-body-cell-date-selected"
                            : "") }, item.date.date()),
                    React.createElement("div", { className: "calendar-month-cell-body-date-content" }, dateInnerContent === null || dateInnerContent === void 0 ? void 0 : dateInnerContent(item.date)))));
            }
            rows.push(row);
        }
        return rows.map(row => React.createElement("div", { className: "calendar-month-body-row" }, row));
    }
    return React.createElement("div", { className: "calendar-month" },
        React.createElement("div", { className: "calendar-month-week-list" }, weekList.map((week) => (React.createElement("div", { className: "calendar-month-week-list-item", key: week }, CalendarLocale.week[week])))),
        React.createElement("div", { className: "calendar-month-body" }, renderDays(allDays)));
}
export default MonthCalendar;
